<template>
  <main class="data-table">

    <list :infiniteId="infiniteId"
          :headers="headers"
          :list="partnersList"
          :loading="false"
          @load="load">
      <template slot="default"
                slot-scope="slotProps">
        <partners-table-item :data-item="slotProps.item"></partners-table-item>
      </template>
    </list>

  </main>
</template>

<script>
import PartnersTableItem from "./components/PartnersTableItem";
import List from "@/components/generic/list/List";
import EventBus from "@packages/event-bus";

export default {
  components: {
    List,
    PartnersTableItem,
  },

  data() {
    return {
      entity: "partners",
      infiniteId: +new Date(),
      partnersList: [],
      page: 0,
      size: "",
      filter: "",
      order: "",
      desc: false,


      loadOnFilters: false,
    };
  },

  computed: {
      headers() {
        return  [
              {text: this.$t('message.admGenerics.message.active'), value: "isActive", width: "60px"},
              {text: this.$t('message.generics.message.name'), value: "name"},
              {text: this.$t('message.admGenerics.message.numberEstablishments'), value: "totalEstablishments"},
              {text: this.$t('message.admGenerics.message.numberLocals'), value: "localAccount"},
              {text: this.$t('message.admGenerics.message.numberLicences'), value: "accessPointCount"},
              {text: this.$t('message.admGenerics.message.registration'), value: "registrationDate"},
              {text: this.$t('message.admGenerics.message.lastLogin'), value: "lastLogin"},
              {text: this.$t('message.admGenerics.message.edition'), value: null, sortable: false},
          ]
      }
  },


  methods: {
    async load($state) {
      const retorno = await this.$api.partners.list({
        page: this.page,
        size: this.size,
        filter: this.filter,
        order: this.order,
      });
      if (retorno.content.length !== 0) {
        this.page++;

        this.partnersList.push(...retorno.content);

        $state.loaded();
      } else {
        $state.complete();
      }
    },
    reload(search) {
      this.page = 0;
      this.partnersList = [];
      this.filter = search;
      this.infiniteId++;
    },
  },
  created() {
    EventBus.$on("LOAD_DATA", this.reload);
  },
  destroyed() {
    EventBus.$off("LOAD_DATA", this.reload);
  },
};
</script>

<style scoped>
</style>
